// components/resetPassword.jsx
import React, { useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { Paper, Typography, TextField, Button } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { backendUrl } from './config';

const useStyles = makeStyles(() => ({
    container: {
        padding: 32,
        maxWidth: 400,
        margin: 'auto',
        backgroundColor: '#fff',
        boxShadow: '0px 2px 4px rgba(0,0,0,0.1)',
        borderRadius: 8,
        marginTop: '64px',
    },
    formField: {
        marginBottom: 16,
        width: '100%',
    },
    submitButton: {
        marginTop: 16,
        width: '100%',
        backgroundColor: '#4b9ef1 !important',
        color: '#fff !important',
    },
}));

const ResetPassword = () => {
    const classes = useStyles();
    const [searchParams] = useSearchParams();
    const token = searchParams.get('token');
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [message, setMessage] = useState('');
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();

        // Validate that the passwords match.
        if (newPassword !== confirmPassword) {
            setMessage('Passwords do not match!');
            return;
        }

        try {
            // Notice the endpoint is updated to /reset-password
            const response = await fetch(`${backendUrl}/reset-password`, {
                method: 'PATCH',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ token, newPassword }),
            });
            const data = await response.json();

            if (!response.ok) {
                setMessage(data.message || 'Failed to reset password.');
            } else {
                setMessage('Password reset successfully. Redirecting to sign in...');
                // Redirect after a short delay to allow user to read the message.
                setTimeout(() => {
                    navigate('/signin');
                }, 3000);
            }
        } catch (error) {
            setMessage("Error: " + error.message);
        }
    };

    return (
        <Paper className={classes.container}>
            <Typography variant="h5" align="center" gutterBottom>
                Reset Password
            </Typography>
            <form onSubmit={handleSubmit}>
                <TextField
                    label="New Password"
                    type="password"
                    variant="outlined"
                    className={classes.formField}
                    value={newPassword}
                    onChange={(e) => setNewPassword(e.target.value)}
                    required
                />
                <TextField
                    label="Confirm New Password"
                    type="password"
                    variant="outlined"
                    className={classes.formField}
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    required
                />
                <Button type="submit" variant="contained" className={classes.submitButton}>
                    Reset Password
                </Button>
            </form>
            {message && (
                <Typography variant="body2" align="center" style={{ marginTop: 16 }}>
                    {message}
                </Typography>
            )}
        </Paper>
    );
};

export default ResetPassword;
